.empty-table{margin-bottom:3em}.vital-sign-submitted .vital-sign.ng-invalid{border:red 1px solid!important;border-radius:2px}.nz-date-input{width:100%;margin-left:0!important}
/*# sourceMappingURL=vital-signs-add-edit.component-RLUNXMUU.css.map */
